import {result, isString} from 'lodash';
import DatasetAttributeModel from './dataset_attribute';
import {ATTRIBUTES} from "../../../../utils/query_utils";

export default class FilterModel extends DatasetAttributeModel {
    type = ATTRIBUTES.FILTER;
    operator = null;
    values = [];
    logicalOperator = 'and';  // and|or

    constructor({operator = null, values = [], ...otherProps} = {}) {
        super(otherProps);
        this.setOperator(operator);
        this.setValues(values);
    }

    setOperator(operator) {
        this.operator = operator;
    }

    setLogicalOperator(logicalOperator) {
        this.logicalOperator = logicalOperator;
    }

    addValue(value) {
        this.values.push(value);
    }

    removeValue(value) {
        this.values.splice(this.values.indexOf(value), 1);
    }

    updateValue(oldValue, newValue) {
        this.values.splice(this.values.indexOf(oldValue), 1, newValue);
    }

    setValues(values = []) {
        if (isString(values)) {
            this.values = values.split(',').map(value => value.trim());
        } else {
            this.values = values.slice();
        }
    }

    isComplete() {
        return super.isComplete() && !!this.operator && this.operator.isValid(this.column, this.values);
    }

    get label() {
        return `${result(this.column, 'fullName', '')} ${result(this.operator, 'label', '')} ${this.values.join(', ')}`.trim();
    }

    get sql() {
        return this.operator.getSql(this.column, this.values);
    }

}
